import { Theme } from ".";
import NavigationDrawer from "@/components/layout/NavigationDrawer";
import cx from "classnames";
import * as React from "react";

type NavItem = {
  title?: string | (() => void);
  path?: string;
  isExternal?: boolean;
  dropdown?: any[];
  onClick?: () => null;
  render?: () => null;
  id?: string;
  className?: string;
  target?: string;
};

type IBrand = { onClick?: () => void; path: string; title: string };

interface INavBarMobileProps extends Theme {
  brand?: IBrand;
  className?: string;
  navs?: any;
  theme?: "light-theme" | "dark-theme" | "transparent-dark-theme";
}

export function Mobile(props: INavBarMobileProps): JSX.Element {
  const [isOpen, setIsOpen] = React.useState(false);

  const { navs, className, theme } = props;

  const rightNav = !Array.isArray(navs) && navs?.right ? navs.right : [];

  function generateClasses() {
    return {
      nav: cx("navbar", "navbar-fixed-top", "navbar-mobile", {
        ["dark-theme"]: theme === "dark-theme",
        "navbar-mobile": !isOpen,
        [className]: className,
      }),
      toggler: "navbar-toggler",
    };
  }

  function onOpen() {
    setIsOpen(true);
  }

  function onClose() {
    setIsOpen(false);
  }

  function renderButton(classes) {
    return (
      <button
        className={classes.toggler}
        style={{ cursor: "pointer" }}
        onClick={onOpen}
        aria-expanded={isOpen}
        aria-label="Open navigation"
      >
        <i className="fa fa-bars" aria-hidden={true} />
      </button>
    );
  }

  const classes = generateClasses();
  return (
    <nav className={classes.nav} role="navigation" aria-label="navigation menu">
      {renderButton(classes)}
      <NavigationDrawer open={isOpen} onOpenChange={onClose} bottomNavItems={rightNav} />
    </nav>
  );
}
